import React, { useState, useEffect, useRef, useContext } from "react";
import "./ModulePermissions.css";
import AwsServerService from "../../../common/util/AwsServerService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFolder,
  faFile,
  faUsers,
  faAngleDown,
  faAngleRight,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faBackward,
  faCaretDown,
  faCaretRight,
  faCartArrowDown,
  faSearch,
  faTrash,
  faWindowRestore,
  faLink,
  faCopy,
  faClock,
  faCog,
} from "@fortawesome/free-solid-svg-icons";
import { Col, Input, Row } from "reactstrap";
import {
  Checkbox,
  Popover,
  Tooltip,
  Select,
  message,
  Modal,
  Button,
  Tabs,
  DatePicker
} from "antd";
import { canAccess } from "../../../common/util/appUtils";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import SelectDealsModal from "./SelectDealsModal";
import { setAccessContext } from "../../../Context/UserContext";
import { getSocket } from "../../../Socket";
import { AppDataRequired } from "../../../App";
import { FaCog } from "react-icons/fa";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import EmailService from "../../../common/util/EmailService";
import customParseFormat from "dayjs/plugin/customParseFormat";
const { Option } = Select;

const ROLE_MAP = {
  Admin: 36,
  Organize: 3,
  Edit: 5,
  View: 6,
  // Upload: 7,
};
const LINKSHARE_ROLE_MAP = {
  5: "Edit",
  34: "View",
  7: "Upload",
};
export default function WorkdrivePermissions({ teamFolders, folderId, selectedFiles }) {
  //   const [teamFolders, setTeamFolders] = useState([]);
  const userInfo = JSON.parse(localStorage.getItem("userinfo")); 
  const [currentFolders, setCurrentFolders] = useState([]);
  const [navigationStack, setNavigationStack] = useState([]);
  const [isMembersOpen, setIsMembersOpen] = useState(false);
  const membersRef = useRef();
  const moduleContacts = useSelector((state) => state.AppReduxContext.moduleContacts);
  // const [selectedFolderId, setSelectedFolderId] = useState(folderId);
  const { AllUsers } = useContext(AppDataRequired);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [accessId, setAccessId] = useState(6);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [folderUser, setFolderUser] = useState([]);
  const [folderInfo, setFolderInfo] = useState([]);
  const [activeTab, setActiveTab] = useState("members");
  const [selectedItems, setSelectedItems] = useState([]);
  const [confirmDelete , setConfirmDelete] = useState(false)
  const [currentFile, setCurrentFile] = useState(null);
  const [linkDeleteData, setLinkDeleteData] = useState([])
  const [sharedItems, setSharedItems] = useState([]);
  const [hoveredId, setHoveredId] = useState(null);
  const [changeSetting, setChangeSetting] = useState(false)
  const [selectedLink, setSelectedLink] = useState(null);
  const [permission, setPermission] = useState(null);
  const [linkName, setLinkName] = useState("");
  const [generatedLinkId, setGeneratedLinkId] = useState("");
  const [generatedLink, setGeneratedLink] = useState("");
  const [expiryDate, setExpiryDate] = useState(null);
  const [linkUsers, setLinkUsers] = useState([])
  const [canUpdate, setCanUpdate] = useState(false)
  const [activeLinkUser, setActiveLinkUsers] = useState(null);
  dayjs.extend(customParseFormat);
  const userOptions = Array.from(
      new Map(
          Object.values(moduleContacts)
          .flat()
          .map((item) => {
              const email = item.Email;
              const name = item.Full_Name || item.name || email;

              return [
              email, // key for uniqueness
              {
                  label: `${name} (${email})`,
                  value: email,
                  name: name
              },
              ];
          })
      ).values()
  );

    const parseExpiry = (dateStr) => {
      if (!dateStr) return null; 
      const now = dayjs(); 
      let parsed = dayjs(dateStr, "MMM D, h:mm A YYYY", true); 
      if (parsed.isValid()) {
        return parsed;
      } 
      parsed = dayjs(
        `${dateStr} ${now.year()}`,
        "MMM D, h:mm A YYYY",
        true
      ); 
      if (parsed.isBefore(now)) {
        parsed = parsed.add(1, "year");
      } 
      return parsed.isValid() ? parsed : null;
    };

  useEffect(() => {
    if (selectedLink) {debugger
      const attr = selectedLink.attributes;
      setLinkName(attr.link_name || "");
      setGeneratedLinkId(selectedLink.id);
      setGeneratedLink(attr.link)
      setExpiryDate(
        attr.expiration_date
          ? dayjs(parseExpiry(attr.expiration_date))
          : null
      );
      setPermission(attr.role_id);
    }
  }, [selectedLink]);
  const getUserThumbnailUrl = (zuid) =>
    "https://contacts.zoho.com/file?ID=" + zuid + "&fs=thumb";

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value.trim() === "") {
      setShowUserDropdown(false);
      setFilteredUsers([]);
      return;
    }

    setShowUserDropdown(true);
    setFilteredUsers(
      AllUsers.filter((user) =>
        user.full_name.toLowerCase().includes(value.toLowerCase()),
      ),
    );
  };
  const handleSelectUser = (user) => {
    const alreadyExists = selectedUsers.find((u) => u.email === user.email);
    if (alreadyExists) return;

    setSelectedUsers([...selectedUsers, user]);
    setSearchTerm("");
    setShowUserDropdown(false);
  };

  const handleAddPermission = async () => {
    debugger;
    if (selectedUsers.length === 0) return;
    await AwsServerService.givePermissionToUser(
      selectedUsers,
      accessId,
      folderId,
      localStorage.getItem("token"),
    ).then((res) => {
      fetchFolderMembers(folderId);
      setSelectedUsers([]);
      setSearchTerm("");
      setAccessId(6);
      message.success("Permission Granted");
    });
  };
  const handleRoleChange = async (member, newRoleId) => {

    AwsServerService.updateMemberRole(member, newRoleId, localStorage.getItem("token"))
    .then((res) => {
      console.log("Role updated successfully:", res.data);
      fetchFolderMembers(folderId);
      message.success("User Role Updated")
      // Optionally update local state to reflect new role immediately
    })
    .catch((err) => {
      console.error("Failed to update role:", err);
    });
  };
  useEffect(() => {
    const handleClickOutside = (e) => {
      const isModalClick = e.target.closest(".ant-modal");
      if (isModalClick) return;
      if (membersRef.current && !membersRef.current.contains(e.target)) {
        setIsMembersOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  
  useEffect(() => {
    if (!isMembersOpen) {
      setAccessId(6);
    }
  }, [isMembersOpen]);
  useEffect(() => {
    fetchFolderMembers(folderId);
    fetchFolderInfo(folderId);
  }, [folderId])

  const handleSelectOne = (file) => {
    setSelectedItems((prev) => {
      const exists = prev.find((item) => item.id === file.id);

      if (exists) {
        return prev.filter((item) => item.id !== file.id);
      } else {
        return [...prev, file];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedItems.length === trashFiles.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(trashFiles);
    }
  };

  const [trashFiles, setTrashFiles] = useState([])
  const fetchTrashData = async () => {debugger
    try {
      await AwsServerService.getTrashData(
        "4snndf1add4f710e14016ba6eb3d69bacb086",
        localStorage.getItem("token"),
      ).then((res) => {
        setTrashFiles(res?.data?.data)
      });
    } catch (err) {
      console.error("fetchTrashData error:", err.message);
    }
  }
  const getExternalSahreLinks = async () => {
    try {
      await AwsServerService.getExternalLinks(
        folderId, localStorage.getItem("token")
      ).then((res) =>{
        const visibleLinks = res?.data?.data.filter(item => {
          const attr = item.attributes;

          return (
            (attr.status === 1 || attr.status === 11) &&
            !attr.is_expired &&
            attr.link
          );
        });
        setSharedItems(visibleLinks)
      })
      await AwsServerService.getLinkSharedUsers(folderId).then((item) => {
        setLinkUsers(item.data)
      })
    } catch (error) {
      console.log("Got exception while feching the external share links..")
    }
  }
  useEffect(() => {
    if (activeTab === "trash") {
      fetchTrashData();
    } else if(activeTab === "shared"){
      getExternalSahreLinks();
    }
    setSelectedUsers([]);
  }, [activeTab]);
  const handleRemoveUser = async (member) => {
    try {
      await AwsServerService.removePermission(
        member?.id,
        localStorage.getItem("token"),
      ).then((res) => {
        setFolderUser((prev) => prev.filter((item) => item.id !== member?.id));
        message.success("Permission Removed");
      });
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const fetchFolderMembers = async (folderId) => {
    debugger;
    const res = await AwsServerService.fetchFolderMembers(
      folderId,
      localStorage.getItem("token"),
    );
    const folderData = res?.data?.data?.filter(
      (item) => item?.attributes?.shared_status == "ACTIVE",
    );
    setFolderUser(folderData);
  };
  
  const fetchFolderInfo = async (folderId) => {
    const res = await AwsServerService.fetchFolderInfo(
      folderId,
      localStorage.getItem("token"),
    );
    setFolderInfo(res?.data?.data);
  };

  const handleRestore = async (file) => {
    if(selectedItems.length > 0){
      await AwsServerService.restoreTrash(file, localStorage.getItem("token")).then(res => {
        message.success(selectedItems.length+" Items Restored Successfully")
        setTrashFiles(prev =>{
          const selectedIds = selectedItems.map(item => item.id);
          return prev.filter(item => !selectedIds.includes(item.id));
        })
        setSelectedItems([])
      })
    } else {
       await AwsServerService.restoreTrash(file, localStorage.getItem("token")).then(res => {
      message.success("Items Restored Successfully")
      setTrashFiles(prev =>{
        return prev.filter(item => item?.id !== file?.id);
      })
      setSelectedItems([])
    })
    }
  };

  const handleDelete = async (file) => {
    if(linkDeleteData && linkDeleteData?.id){
      await AwsServerService.revokeSharedLink(file, localStorage.getItem("token")).then(res => {
        getExternalSahreLinks();
        setLinkDeleteData([]);
        message.success("Shared link deleted successfully")
      })
    } else
    if(selectedItems.length > 0){
      await AwsServerService.deleteFolderPermanantly(file, localStorage.getItem("token")).then(res => {
        message.success(selectedItems.length+" Items Deleted Permananly")
        setTrashFiles(prev =>{
          const selectedIds = selectedItems.map(item => item.id);
          return prev.filter(item => !selectedIds.includes(item.id));
        })
        setSelectedItems([])
      })
    } else {
       await AwsServerService.deleteFolderPermanantly(file, localStorage.getItem("token")).then(res => {
      message.success("Items Deleted Permananly")
      setTrashFiles(prev =>{
        return prev.filter(item => item?.id !== file?.id);
      })
      setSelectedItems([])
    })
    }
  };

  const getTimeAgo = (file) => {
    const timestamp = file?.attributes?.status_change_time_in_millisecond;
    const user = file?.attributes?.modified_by || file?.attributes?.created_by;

    const now = Date.now();
    const diff = now - timestamp;

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days < 1) {
      if (hours >= 1) return `${hours} hour ago by ${user}`;
      if (minutes >= 1) return `${minutes} minutes ago by ${user}`;
      return `Just now by ${user}`;
    }

    const date = new Date(timestamp).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });

    return `${date} by ${user}`;
  };

  const clearSelection = () => {
    setSelectedItems([])
  };

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      message.info("Link copied to Clipboard")
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  const handleUpdate = async () =>{
    await AwsServerService.UpdateLinkShareDetails(selectedLink, linkName, expiryDate, permission, localStorage.getItem("token")).then(res =>{
      message.success("Updated Successfully");
      // setSelectedLink(null)
      setChangeSetting(false)
      getExternalSahreLinks();
    }).catch((err) =>{
      console.log(err)
    });
  }
  const handleSendEmail = async () =>{debugger
    const expiration = new Date(expiryDate)
    .toISOString()
    .slice(0, 19)
    .replace("T", " ");
    const payLoad = {
        FolderId: folderId,
        LinkId: generatedLinkId,
        Users: JSON.stringify(selectedUsers),
        ExpirationDate: expiration,
        CREATEDBY: userInfo.email_id
    };
    const abc = payLoad
    await AwsServerService.AddUserToLink(payLoad).then()
    if(generatedLink){
        await EmailService.GetCurrentEmailAccount(userInfo?.email_id).then( async result => {
            for (const user of selectedUsers) {
                const emailContent = `
                <div>
                    <p>Hello, ${user.label.split(' (')[0]}</p>
                    <p>You have been given access to a shared link.</p>
                    <p><b>Name:</b> <a href="${generatedLink}">${linkName}</a></p><a src={}></>
                    <p><b>Expires On:</b> ${expiryDate?.format("YYYY-MM-DD")}</p>
                    <br/>
                    <p>Regards,<br/>Your Team</p>
                </div>
                `;
                const emailPayload = {
                    fromAddress: userInfo?.email_id,
                    toAddress: user.value,
                    subject: `Shared Link: ${linkName}`,
                    askReceipt: "no",
                    content: emailContent,
                    mailFormat: "html",
                };
                // if (cc) emailPayload.ccAddress = cc;
                // if (bcc) emailPayload.bccAddress = bcc;
                await EmailService.SendEmail(result?.data[0]?.accountId, emailPayload);
                // setExpiryDate(dayjs().add(14, "day"));
                // setLinkName("");
                setSelectedUsers([]);
                // setSelectedLink(null);
                // setChangeSetting(false);
            }
            message.success("Email Send Successfully")
            setSelectedUsers([]);
            // setGeneratedLinkId("")
            // setGeneratedLink("")
        }).catch(error => {
            console.error("Error fetching email account:", error);
        });
    }
  }
  const tabItems = [
    {
      key: "details",
      label: "Team Folder Details",
      children: (
        <div style={{ padding: "20px", background: "#fff" }}>
          {folderInfo && (
            <div style={{ display: "flex", alignItems: "stretch",}}>
              <div style={{ flex: 1, paddingRight: "30px" }}>
                <p><strong>Name</strong></p>
                <p style={{ marginBottom: "15px" }}>
                  {folderInfo?.attributes?.name}
                </p>

                <p><strong>Description</strong></p>
                <p style={{ marginBottom: "20px" }}>
                  {folderInfo?.attributes?.description}
                </p>

                <p><strong>Created by</strong></p>
                <p>{folderInfo?.attributes?.created_by}</p>

                <p><strong>Size</strong></p>
                <p>{folderInfo?.attributes?.storage_info?.size}</p>

              </div>

              <div
                style={{
                  width: "1px",
                  background: "#e5e7ebad",
                  margin: "0 30px",
                }}
              />

              <div style={{ width: "250px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <strong>{folderUser?.length} Members</strong>
                  <span
                    style={{ cursor: "pointer", color: "#2563eb", fontWeight: 500 }}
                    onClick={() => setActiveTab("members")}
                  >
                    + Add Members
                  </span>
                </div>

                <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
                  {folderUser?.map((member, index) => (
                    <img
                      key={index}
                      src={member?.attributes?.share_to_entity_info?.avatar_url}
                      alt="user"
                      style={{
                        width: "45px",
                        height: "45px",
                        borderRadius: "6px",
                        objectFit: "cover",
                        border: "1px solid #ddd",
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      ),
    },
    {
      key: "members",
      label: `Members (${folderUser.length})`,
      children: (
        <div>
              <div style={{ padding: "16px", borderBottom: "1px solid #eee" }}>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div style={{ flex: 1, position: "relative" }}>
                    {/* Input + Chips Container */}
                    <div
                      style={{
                        border: "1px solid #d1d5db",
                        borderRadius: "6px",
                        padding: "6px",
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                        gap: "6px",
                        cursor: "text",
                      }}
                      onClick={() =>
                        document.getElementById("user-input").focus()
                      }
                    >
                      {selectedUsers.map((user) => (
                        <div
                          key={user.email}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            background: "#e5e7eb",
                            padding: "4px 8px",
                            borderRadius: "16px",
                            fontSize: "12px",
                          }}
                        >
                          {user.full_name}
                          <span
                            style={{ marginLeft: "6px", cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedUsers(
                                selectedUsers.filter(
                                  (u) => u.email !== user.email,
                                ),
                              );
                            }}
                          >
                            ✕
                          </span>
                        </div>
                      ))}

                      <input
                        id="user-input"
                        type="text"
                        value={searchTerm}
                        onChange={handleInputChange}
                        placeholder={
                          selectedUsers.length === 0 ? "Add members..." : ""
                        }
                        style={{
                          border: "none",
                          outline: "none",
                          flex: 1,
                          minWidth: "120px",
                          fontSize: "14px",
                        }}
                      />
                    </div>

                    {/* Dropdown MUST be here */}
                    {showUserDropdown && filteredUsers.length > 0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "110%",
                          left: 0,
                          width: "100%",
                          maxHeight: "150px",
                          overflowY: "auto",
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          zIndex: 1000,
                        }}
                      >
                        {filteredUsers.map((user) => (
                          <div
                            key={user.email}
                            style={{
                              padding: "8px",
                              cursor: "pointer",
                              borderBottom: "1px solid #eee",
                            }}
                            onClick={() => handleSelectUser(user)}
                          >
                            <img
                              className="User-Image"
                              src={getUserThumbnailUrl(user.zuid)}
                            />
                            {user.full_name}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Role Dropdown */}
                  
                  <select
                    value={accessId}
                    onChange={(e) => setAccessId(e.target.value)}
                    style={{
                      padding: "10px",
                      borderRadius: "6px",
                      border: "1px solid #d1d5db",
                      background: "#fff",
                    }}
                  >
                    {Object.entries(ROLE_MAP).map(([label, id]) => (
                      <option key={id} value={id}>
                        {label}
                      </option>
                    ))}
                  </select>
                    
                  {/* Add Button */}
                  <button
                    onClick={handleAddPermission}
                    style={{
                      background: "#2563eb",
                      color: "#fff",
                      border: "none",
                      padding: "10px 16px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      fontWeight: "500",
                    }}
                  >
                    Add
                  </button>
                </div>
              </div>

              {/* Members Header */}
              <div
                style={{
                  padding: "12px 16px",
                  fontWeight: "600",
                  fontSize: "14px",
                  borderBottom: "1px solid #eee",
                }}
              >
                {folderUser.length} Members
              </div>

              {/* Members List */}
              <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                {folderUser.map((member, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "12px 16px",
                      borderBottom:
                        idx !== folderUser.length - 1
                          ? "1px solid #f1f1f1"
                          : "none",
                    }}
                  >
                    {/* Avatar */}
                    <img
                      className="User-Image"
                      src={member?.attributes?.share_to_entity_info?.avatar_url}
                    />

                    {/* Name + Email */}
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: "500", fontSize: "14px" }}>
                        {member.attributes.share_to_entity_info.display_name}
                      </div>
                      <div style={{ fontSize: "12px", color: "#6b7280" }}>
                        {member.attributes.share_to_entity_info.email_id}
                      </div>
                    </div>

                    {/* Remove */}
                    {member.attributes.role_id != 1 ? (
                      <>
                        <select
                          value={member.attributes.role_id}
                          onChange={(e) =>
                            handleRoleChange(member, parseInt(e.target.value))
                          }
                          style={{
                            border: "1px solid #d1d5db",
                            borderRadius: "6px",
                            padding: "6px 8px",
                            fontSize: "13px",
                            marginRight: "10px",
                            background: "#fff",
                          }}
                        >
                          {Object.entries(ROLE_MAP).map(([label, id]) => (
                            <option key={id} value={id}>
                              {label}
                            </option>
                          ))}
                        </select>
                        <div
                          style={{
                            cursor: "pointer",
                            color: "#9ca3af",
                            fontSize: "16px",
                          }}
                          onClick={() => handleRemoveUser(member)}
                        >
                          ✕
                        </div>
                      </>
                    ) : (
                      <>
                        <div style={{ fontWeight: "500", marginRight: "45px" }}>
                          {
                            Object.entries(ROLE_MAP).find(
                              ([label, id]) => id === member.attributes.role_id,
                            )?.[0]
                          }
                        </div>
                        <div
                          style={{
                            cursor: "not-allowed",
                            color: "#9ca3af",
                            fontSize: "16px",
                            pointerEvents: "none",
                          }}
                        >
                          ✕
                        </div>
                      </>
                    )}
                  </div>
                ))}
              {/* </div> */}
            </div>
          {/* )} */}
        </div>
      ),
    },
    // {
    //   key: "settings",
    //   label: "Settings",
    //   children: <div style={{marginLeft:"40%", marginTop:"15%"}}>Settings Content</div>,
    // },
    {
      key: "trash",
      label: "Trash",
      children: (
         <>
        <div className="trash-container" style={{paddingTop:"0px"}}>
          <div className="trash-header">
            <input placeholder="Search" />
            {/* <button className="empty-btn">Empty Trash</button> */}
          </div>

          <div className="trash-table-header">
            {selectedItems.length > 0 ? (
              <>
              <div className="th-left">
                  <input
                    type="checkbox"
                    checked={
                      trashFiles.length > 0 &&
                      selectedItems.length === trashFiles.length
                    }
                    ref={(el) => {
                      if (el) {
                        el.indeterminate =
                          selectedItems.length > 0 &&
                          selectedItems.length < trashFiles.length;
                      }
                    }}
                    onChange={handleSelectAll}
                  />
                  {selectedItems.length} selected
                </div>

                <div className="th-middle">
                  <button className="btn btn-sm btn-outline-primary" 
                    onClick={() => handleRestore(selectedItems)}
                    style={{marginRight:"5px", padding: "5px"}}
                    >
                    <FontAwesomeIcon icon={faWindowRestore} /> Restore
                  </button>

                  <button
                    className="btn btn-sm btn-outline-primary delete"
                    style={{padding: "5px"}}
                    onClick={() => setConfirmDelete(true)}
                  >
                   <FontAwesomeIcon icon={faTrash} /> Delete
                  </button>
                </div>

                <div className="th-right" onClick={() => clearSelection()}>
                  <button className="btn btn-sm btn-outline-secondary"
                    style={{padding: "5px"}}
                  >
                    Esc ✕
                  </button>
                  </div>
              </>
            ) : (
              <>
                <div className="th-left">
                  <input
                    type="checkbox"
                    checked={
                      trashFiles.length > 0 &&
                      selectedItems.length === trashFiles.length
                    }
                    onChange={handleSelectAll}
                  />
                  <span>Name</span>
                </div>

                <div className="th-middle">Deleted</div>

                <div className="th-right">Actions</div>
              </>
            )}
          </div>

          <div className="trash-list">
            {trashFiles && trashFiles.length > 0 ? (
              trashFiles.map((file, i) => (
                <div className="trash-row" key={i}>
                  <div className="trash-left">
                    <input
                      type="checkbox"
                      checked={selectedItems.some(item => item.id === file.id)}
                      onChange={() => handleSelectOne(file)}
                    />

                    <span className="icon">📁</span>

                    <div>
                      <div className="file-name">{file?.attributes?.name}</div>
                      <div className="file-sub">
                        Uploaded by {file?.attributes?.created_by}
                      </div>
                    </div>
                  </div>

                  <div className="trash-middle">
                    <span className="time">{getTimeAgo(file)}</span>
                  </div>

                  <div className="trash-right">
                    <div className="actions">
                      <div onClick={() => handleRestore(file)}>
                        <FontAwesomeIcon icon={faWindowRestore} />
                      </div>

                      <div
                        className="delete"
                        onClick={() => {setCurrentFile(file); setConfirmDelete(true)}}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center", marginTop: "40px", color: "#888" }}>
                Trash is empty
              </div>
            )}
          </div>
        </div>
        </>
      ),

    },
    // {
    //   key: "activity",
    //   label: "Activity",
    //   children: <div style={{marginLeft:"40%", marginTop:"15%"}}>Activity Content</div>,
    // },
    {
      key: "shared",
      label: "Shared Items",
      children: 
      <div style={{}}>
       {sharedItems.map((item) => (
        <>
          <div
            key={item.id}
            onMouseEnter={() => setHoveredId(item.id)}
            onMouseLeave={() => setHoveredId(null)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "12px 16px",
              borderRadius: "10px",
              backgroundColor: "#f5f6f7",
              border: "1px solid #e0e0e0",
              marginBottom: "10px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "8px",
                  backgroundColor: "#e0e0e0",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "16px",
                  color:"#0069d9"
                }}
              >
                <FontAwesomeIcon icon={faLink} />
              </div>

              <div>
                <div style={{ fontSize: "14px", fontWeight: "500", color: "#333", display:"flex", justifyContent:"space-between" }}>
                  <div>
                    {item.attributes.link_name || item?.attributes?.file_name}
                  </div>
                  <div 
                    style={{ color: "#0069d9", cursor: "pointer" }}
                    title={`Share link expires on ${item?.attributes?.expiration_date}`}
                  >
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div style={{padding:"0px 8px", background:"#cbe7f2", border: "1px solid #c7c7c7",}}>
                    {LINKSHARE_ROLE_MAP[item.attributes.role_id] || "Unknown"} Access
                  </div>
                </div>

                <div style={{ fontSize: "12px", color: "#777" }}>
                  Creaed by {item?.attributes?.created_by} on {item?.attributes?.created_time}
                </div>
              </div>
            </div>

            <div
              onClick={() => handleCopy(item.attributes.link)}
              style={{
                opacity: hoveredId === item.id ? 1 : 0,
                transform: hoveredId === item.id ? "scale(1)" : "scale(0.8)",
                transition: "0.2s",
                cursor: "pointer",
                fontSize: "16px",
                marginLeft: "35%",
                color:"#0069d9"
              }}
              title="Copy link"
            >
              <FontAwesomeIcon icon={faCopy} />
            </div>
            <div
              style={{position:"relative"}}
            >
             <button
              onClick={() => {
                setActiveLinkUsers(activeLinkUser == item?.id ? null : item?.id)
              }}
              style={{
                padding: "6px 14px",
                borderRadius: "8px",
                border: "1px solid #c7c7c7",
                backgroundColor: "#fff",
                cursor: "pointer",
                fontSize: "13px",
                color:"#0069d9"
              }}
            >
              <FontAwesomeIcon icon={faUsers} /> {linkUsers
                                            .filter((u) => u?.LinkId === item?.id)
                                            .reduce((total, curr) => total + (curr.Users?.length || 0), 0)}
            </button>
            {activeLinkUser === item.id &&
              linkUsers.filter((u) => u?.LinkId === item?.id).length > 0 && (
                <div
                  style={{
                    position: "absolute",
                    top: "110%",
                    left: 0,
                    height:"205px",
                    width: "400px",
                    background: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    zIndex: 1000,
                    padding: "8px",
                    overflowY:"auto"
                  }}
                >
                  <div
                    style={{
                      maxHeight:
                        linkUsers.filter((u) => u?.LinkId === item?.id).length > 4
                          ? "160px"
                          : "auto",
                      overflowY:
                        linkUsers.filter((u) => u?.LinkId === item?.id).length > 4
                          ? "auto"
                          : "visible",
                    }}
                  >
                    {linkUsers
                      .filter((u) => u?.LinkId === item?.id)
                      .flatMap((u) => u?.Users || [])
                      .map((user, idx) => (
                        <div
                          key={idx}
                          style={{
                            padding: "6px 8px",
                            fontSize: "13px",
                            borderBottom: "1px solid #f0f0f0",
                          }}
                        >
                          {user.label || user.value || "Unknown user"}
                        </div>
                      ))
                    }
                  </div>
                </div>
              )}
            </div>
            <button
              onClick={() => {
                setSelectedLink(item);
                setChangeSetting(true);
              }}
              
              style={{
                padding: "6px 14px",
                borderRadius: "8px",
                border: "1px solid #c7c7c7",
                backgroundColor: "#fff",
                cursor: "pointer",
                fontSize: "13px",
                color:"#0069d9"
              }}
            >
              <FontAwesomeIcon icon={faCog} />
            </button>

            <button
              onClick={() => {debugger
                setLinkDeleteData(item)
                setConfirmDelete(true)
              }}
              style={{
                padding: "6px 14px",
                borderRadius: "8px",
                border: "1px solid #c7c7c7",
                backgroundColor: "#fff",
                cursor: "pointer",
                fontSize: "13px",
                color:"#ff0000"
              }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        </>
        ))}
        
      </div>
    },
  ];
  return (
    <>
    <div className="workdrive-container">
      <div className="workdrive-header">

        <div
          ref={membersRef}
          style={{ position: "fixed", display: "inline-block" }}
        >
          <div
            style={{
              marginTop:"20px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              cursor: "pointer",
            }}
            onClick={() => {
              setIsMembersOpen(prev => {
                const next = !prev;
                if (next) {
                  setActiveTab("members");
                  setSelectedItems([]);
                }
                return next;
              });
            }}
          >
            <FontAwesomeIcon style={{color:"#2566e8"}} icon={faUsers} />
            {folderUser.length}
            {/* <span>Members</span> */}
          </div>
            {isMembersOpen && (

              <div
                style={{
                  position: "fixed",
                  marginTop: "7%",
                  width: "750px",
                  background: "#fff",
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                  zIndex: 1000,
                  height: "55%",
                }}
              >
                <Tabs
                  // defaultActiveKey="details"
                  activeKey={activeTab}
                  onChange={setActiveTab}
                  items={tabItems}
                  tabBarStyle={{ padding: "0 16px" }}
                />
              </div>
            )}
          
        </div>
      </div>

    </div>
    <Modal
        style={{left: "0px" }}
        rootClassName="folder-trash-modal"
        open={confirmDelete}
        onCancel={() => setConfirmDelete(false)}
        footer={null}
        centered
      >
        <div style={{ display: "flex", gap: "12px" }}>
          <div style={{ fontSize: "22px", color: "#d97706" }}>⚠️</div>

          <div>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "600",
                marginBottom: "8px",
              }}
            >
              {linkDeleteData && linkDeleteData?.id  ? 
                (<>Delete share link?</>)  
                : (<>Delete {selectedItems.length || 1} folder from Trash?</>)
              }
            </div>

            <div style={{ fontSize: "14px", color: "#444", lineHeight: "1.6" }}>
            {linkDeleteData && linkDeleteData?.id ? 
              (<>External users with this share link {linkDeleteData?.attributes?.link_name} can no longer access your folder.</>) 
              : (<>Files and folders deleted from the Trash will be temporarily moved to Deleted Items in the Admin Console 
              before they are permanently deleted from your team after 90 days based on the{" "}
              <span
                style={{ color: "#0b65c2", cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    "https://help.zoho.com/portal/en/kb/workdrive/admin-console/settings/articles/data-retention-policy",
                    "_blank",
                  )
                }
              >
                Data Retention Policy.
              </span>
              <br />
              </>)
              }
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
                gap: "10px",
              }}
            >
              <button
                onClick={() => {
                  setConfirmDelete(false);
                  setLinkDeleteData([])
                }}
                style={{
                  padding: "8px 16px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  background: "#fff",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>

              <button
                onClick={() => {
                  if(linkDeleteData && linkDeleteData?.id){
                    handleDelete(linkDeleteData);
                  } else
                  if (selectedItems.length > 0) {
                    handleDelete(selectedItems);
                  } else {
                    handleDelete(currentFile);
                    setCurrentFile(null)
                  }
                  setLinkDeleteData([])
                  setConfirmDelete(false);
                }}
                style={{
                  padding: "8px 16px",
                  borderRadius: "6px",
                  background: "#1976d2",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "500",
                }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        styles={{
            content: { left: "-20%" }
        }}
        open={changeSetting}
        onCancel={() => setChangeSetting(false)}
        footer={null}
        centered
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <div style={{ fontSize: "18px", fontWeight: "600" }}>
                {linkName}
                </div>

                <Row gutter={8}>
                    <Col span={12}>
                        <div className="floating-field">
                        <span className="floating-label">Link Name</span>
                            <Input
                            placeholder="Link Name"
                            value={linkName}
                            onChange={(e) => {setLinkName(e.target.value); setCanUpdate(true)}}
                            />
                        </div>
                    </Col>

                    <Col span={12}>
                        <div className="floating-field">
                        <span className="floating-label">Expiration Date</span>
                            <DatePicker
                            style={{ width: "100%" }}
                            placeholder="Expiration Date"
                            value={expiryDate}
                            onChange={(date) => {
                              debugger
                              setExpiryDate(date); setCanUpdate(true)}}
                            />
                        </div>
                    </Col>
                </Row>

                <Row gutter={8}>
                    <Col span={12}>
                        <div className="floating-field">
                        <span className="floating-label">Permission</span>
                            <Select
                            placeholder="Permission"
                            value={permission}
                            onChange={(val) => {setCanUpdate(true); setPermission(val);}}
                            style={{ width: "100%"}}
                            options={[
                                { label: "Edit", value: 5 },
                                { label: "View", value: 34 },
                                { label: "Upload", value: 7 },
                            ]}
                            />
                        </div>
                    </Col>
                    <Col span={12}></Col>
                </Row>
                    <Row gutter={8}>
                        <Col span={21}></Col>
                        <Col span={3} style={{display:"flex", justifyContent:"flex-end"}}>
                        <div style={{ display: "flex", gap: "8px" }}>
                        {/* <Button
                            style={{ flex: 1 }}
                            onClick={() =>{
                                setExpiryDate(null)
                                setLinkName("")
                                setSelectedUsers([])
                                setPermission(null)
                            }
                            }
                            >
                            Cancel
                        </Button> */}
                        <Button
                            type="btn btn-sm btn-primary"
                            style={{ flex: 1, backgroundColor: "#007bff"}}
                            disabled={!canUpdate}
                            onClick={() =>
                                {
                                    handleUpdate()
                                }            
                            }
                            >
                            Update
                        </Button>
                        </div>
                        </Col>
                    </Row>
                    <Row><Col span={12}><strong>Share Link via email</strong></Col></Row>
                    <Row gutter={8}>
                        <Col span={12}>
                            <div className="floating-field">
                            <span className="floating-label">Select Contacts</span>
                                <Select
                                    mode="multiple"
                                    placeholder="Select Contacts"
                                    value={selectedUsers}
                                    onChange={(val) => setSelectedUsers(val)}
                                    options={userOptions}
                                    // options={userOptions.filter((option) => {
                                    //   const linkedUserEmails = new Set(
                                    //     linkUsers.flatMap((item) =>
                                    //       (item.Users || []).map((user) => user.value)
                                    //     )
                                    //   );

                                    //   return !linkedUserEmails.has(option.value);
                                    // })}
                                    style={{ width: "100%" }}
                                    showSearch
                                    optionFilterProp="label"
                                    labelInValue
                                />
                            </div>
                        </Col>
                
                      <Col span={6}>
                      </Col>
                      <Col span={6}>
                        <Button
                          type="primary"
                          style={{ width: "100%", backgroundColor: "#007bff" }}
                          disabled={!selectedUsers.length}
                          onClick={() => handleSendEmail()}
                        >
                          Send Email
                        </Button>
                      </Col>
                    </Row>
            </div>
      </Modal>
    </>
  );
}
